import React from 'react'

class Application extends React.Component {
  render() {
    return (
      <div>
        { this.props.children }
      </div>
    )
  }
}

export default Application;


// WEBPACK FOOTER //
// ./app/javascript/app/layouts/application/index.jsx